// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__33r73","footer":"ModalError_footer__2WrXF"};